import React from 'react';
import Collapse from '@mui/material/Collapse';

import { Typography, Card, CardHeader, CardContent } from '@occc-app/design-system';

import { ActionCreators } from '../redux';
import { Switch } from '../../Switch';

type Props = {
  children?: any;
  limitToggleUpdate: ActionCreators['LimitToggleUpdate'];
  description: string;
  type: string;
  isActive: boolean;
  name: string;
};

const LimitType: React.FC<Props> = ({
  children,
  limitToggleUpdate,
  description,
  type,
  isActive,
  name,
}) => {
  const handleOnClick = () => {
    limitToggleUpdate(type);
  };

  const renderTitle = () => (
    <Typography component='h4' variant='h6' gutterBottom>
      Configure a {name} limit (optional)
    </Typography>
  );
  const renderAction = () => (
    <Switch label={isActive ? 'On' : 'Off'} checked={isActive} onClick={handleOnClick} />
  );

  return (
    <Card variant='outlined'>
      <CardHeader
        title={renderTitle()}
        subheader={<Typography>{description}</Typography>}
        action={renderAction()}
      />
      <Collapse in={isActive} timeout='auto'>
        <CardContent>{children}</CardContent>
      </Collapse>
    </Card>
  );
};

export { LimitType };
